import { render, staticRenderFns } from "./AdminPostGroupCreate.vue?vue&type=template&id=aea70eee"
import script from "./AdminPostGroupCreate.vue?vue&type=script&lang=js"
export * from "./AdminPostGroupCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports